module.exports = __webpack_public_path__ + "media/images/products/wedding/img-compensation-case3-f010e1c8223e927cea98d8877594f95e.png";